import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useImpersonation } from "@/contexts/ImpersonationContext";

/**
 * VIB-3050: er den aktive brukeren booker? Da får hen Leads selv om rollen ikke har
 * menynøkkelen (ansatte som cold caller i tillegg til rollen sin). Samme regel som
 * crm_user_can_use_leads() i databasen. Leser for aktiv bruker, så impersonering viser det riktige.
 */
export function useIsLeadBooker(): boolean {
  const { activeUser } = useImpersonation();
  const { data } = useQuery({
    queryKey: ["lead-booker", activeUser?.id],
    queryFn: async (): Promise<boolean> => {
      const { data: row, error } = await supabase
        .from("lead_queue_settings")
        .select("is_booker")
        .eq("user_id", activeUser!.id)
        .maybeSingle();
      if (error) throw error;
      return row?.is_booker === true;
    },
    enabled: !!activeUser?.id,
    staleTime: 5 * 60 * 1000,
  });
  return data ?? false;
}

/** Menynøkler som også åpnes av å være booker. */
export const LEAD_BOOKER_MENU_KEYS: readonly string[] = ["salgsmuligheter.leads"];

/** Rollens tilgang, utvidet med «er booker» for Leads (VIB-3050). */
export function withLeadBooker(menuKey: string, roleAccess: boolean, isBooker: boolean): boolean {
  return roleAccess || (isBooker && LEAD_BOOKER_MENU_KEYS.includes(menuKey));
}
